import axios from 'axios'
import * as Sentry from '@sentry/react'
import { attachAuthRefreshInterceptor } from '../api/authRefresh'
import { API_URL } from '../config'
import {
  handleSubscriptionExpiredSession,
  isSubscriptionExpiredError,
} from './subscriptionExpired'

const api = axios.create({ baseURL: API_URL })

attachAuthRefreshInterceptor(api, API_URL)

// Capture unexpected (non-401, non-404) HTTP errors to Sentry for visibility.
// 401s are handled by the auth refresh interceptor; 404s are expected business logic.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (isSubscriptionExpiredError(error)) {
      Sentry.addBreadcrumb({
        message: 'Subscription expired - clearing local session',
        level: 'info',
        data: { url: error.config?.url },
      })
      handleSubscriptionExpiredSession()
      return Promise.reject(error)
    }

    const status = error?.response?.status
    if (status && status !== 401 && status !== 404) {
      Sentry.captureException(error, {
        tags: {
          module: 'api',
          http_status: String(status),
          http_method: (error.config?.method ?? 'unknown').toUpperCase(),
        },
        extra: {
          url: error.config?.url,
          baseURL: error.config?.baseURL,
          status,
        },
      })
    }
    return Promise.reject(error)
  }
)

export default api
